const permissions = {
    search_placeholder: '通过接口或权限名称搜索',
    search_placeholder_without_api: '通过权限名称搜索',
    name_column: '权限',
    description_column: '描述',
    api_column: '接口',
    placeholder_title: '权限',
    placeholder_description: '权限是指访问资源的授权（我们称其为接口资源）。',
    edit: '编辑权限',
    delete: '删除权限',
    remove: '移除权限',
    edit_title: '编辑接口权限',
};
export default Object.freeze(permissions);
